import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(_theme => ({
  homePaper: {
    padding: '16px 24px',
    minHeight: '400px'
  }
}))
